export class MonashCourse {
    constructor(public courseCode?: string,
                public courseName?: string,
                public major?: string,
                public facultyName?: string,
                public facultyCode?: string,
                public course?: any,
                public campus?: string) {
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/model/MonashCourse.ts